import {redirectLogin} from "../utils/utils";

const RedirectLoginRoute = () => {
  return redirectLogin();
};

export default RedirectLoginRoute;
